<script> 
  export default {
    name: 'FormWrapper'
  }
</script>

<template>
  <div class="FormWrapper">
    <slot></slot>
  </div>
</template>

<style lang="scss" scoped>
  .FormWrapper {
  --form-wrapper-gap: 1.5rem;
    display: flex;
    flex-direction: column;
    gap: var(--form-wrapper-gap);
  }
</style>
